import { TCellComponent } from '../List';
import { Label } from 'semantic-ui-react';
import { CSSProperties } from 'react';
import Color, { LuminanceAlgorithm } from '@interaktiv.de/colors';

// collective.solr 10 leaves an empty field out of the Solr document,
// then interaktiv.solr sends '' instead of a list
const DepartmentsCellContent: TCellComponent<string[] | string> = ({
  data,
}) => (
  <div className="ui labels">
    {(Array.isArray(data) ? data : []).map((department) => {
      const [abbreviation, color, title, id] = department.split('|') as [
        string,
        string,
        string,
        string,
      ];

      return (
        <Label
          className="department-button"
          key={abbreviation}
          style={
            {
              '--bg-color': color,
              '--text-color':
                new Color(color).calculateLuminance(
                  LuminanceAlgorithm.W3C_AERT,
                ) > 0.5
                  ? 'var(--horn-black)'
                  : 'var(--horn-white)',
            } as CSSProperties
          }
          data-id={id}
        >
          <abbr title={title} aria-label={`Fachbereich: ${title}`}>
            {abbreviation}
          </abbr>
        </Label>
      );
    })}
  </div>
);

export default DepartmentsCellContent;
